export default {
    data(){
      return {
        isLoading: true,
        result: {
          today: {
            cost: 0,
            discount: 0,
            total: 0
          },

          total: {
            cost: 0,
            discount: 0,
            total: 0
          },
          normal: {
            cost: 0,
            discount: 0,
            total: 0
          },
          expired: {
            cost: 0,
            discount: 0,
            total: 0
          },
          inactive: {
            cost: 0,
            discount: 0,
            total: 0
          },
          hidden: {
            cost: 0,
            discount: 0,
            total: 0
          }
        }
      }
    },
  
    computed: {
      user() {
        return this.$store.state.auth.user;
      }
    },
  
    methods: {
      async load(){
        this.isLoading = true;
        let rs = await this.$api.statistic.cpd().call();
        if (rs.success) this.result = rs.response.result;
        this.isLoading = false;
      }
    },
  
    mounted() {
      this.load();
    },
}